import Books from './Books';

const Home = () => (
  <div className="home">
    <Books />
  </div>
);

export default Home;
